import { InjectionToken } from '@angular/core';
import type * as Rx from 'rxjs';

export const WEBSOCKET_TEST_SCHEDULER = new InjectionToken<Rx.SchedulerLike>(
  'WebsocketTestScheduler',
);

export const RECONNECT_CONFIG = new InjectionToken<Rx.SchedulerLike>(
  'Reconnect Configuration',
);

export const RANDOM_NUMBER_PROVIDER = new InjectionToken<Rx.SchedulerLike>(
  'Random Number Provider',
);

export enum OnMessageTrackedEventTypes {
  MESSAGES_PRIVATE = 'messages-private',
}

export const ON_MESSAGE_TRACKING_CONFIG: {
  readonly [index: string]: boolean;
} = {
  [OnMessageTrackedEventTypes.MESSAGES_PRIVATE]: true,
};
